///  This directive manages focus on items which can be removed from the DOM and are in a ng-repeat.
///  Focus will move to the next item in the list, or previous if there is no next item.
///  if there are no more items in the list, then move to the parent.

///  Dependent on scope property 'isDeleting' is set to true before destroy event.

module.exports = function (moveFocus) {
    return function (scope, element) {
        scope.$on('$destroy', function () {
            if (scope.$$childTail.isDeleting) {
                const $parent = element.parent();
                const $elemNext = element.next();
                const $elemToFocus = $elemNext.length && element[0].nodeName === $elemNext[0].nodeName ? $elemNext : element.prev();

                // move focus if element to focus is the same as this, or move to parent element.
                moveFocus($elemToFocus.length && element[0].nodeName === $elemToFocus[0].nodeName ? $elemToFocus : $parent);
            }
        });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/movefocus/movefocus-afterdelete-directive.js
 **/